import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
 
 
 
 
export default function CadastralNomeCompleto({
  data,
}: {
  data: any
}) {
  const { t } = useTranslation();
  
  return (
    <Panel header='Cadastral Nome Completo' style={{width:'98%'}}>
       
       <DataTable size="small" value={data.DADOS_GERAIS.DADOS} tableStyle={{ minWidth: '50rem' }}>
          <Column field="TIPO_PESSOA" header={t('tipo')}></Column>
          <Column field="DOCUMENTO" header={t('documento')}></Column>
          <Column field="NOME" header={t('nome')}></Column>
          <Column field="NASCIMENTO" header={t('dataNascimento')}></Column>
          <Column field="NOME_DA_MAE" header={t('nomeMae')}></Column>
          <Column field="CIDADE" header={t('cidade')}></Column>
          <Column field="UF" header={t('UF')}></Column>
      </DataTable>
    </Panel>
  )
}